import { Play } from "../StatusIcones/play";
import { StatusEtapaGerenciarEmplacamentosEnum } from "../../enums/StatusEtapaGerenciarEmplacamentos.enum";
import { EtapaGerenciarEmplacamentosEnum } from "../../enums/EtapaGerenciarEmplacamentos.enum";
import { IListarEmplacamentosPR } from "../../Interfaces/IListarEmplacamentosPR";
import { Indisponivel } from "../StatusIcones/indisponivel";
import { Finalizado } from "../StatusIcones/finalizado";
import { Erro } from "../StatusIcones/erro";
import { Processando } from "../StatusIcones/processando";

interface HandleStatusGerarProcessoDigitalProps {
  idProcesso: number;
  abrirModalPularGerarProcessoDigital: (idProcesso: number) => void;
  dados: IListarEmplacamentosPR[];
  etapa: EtapaGerenciarEmplacamentosEnum;
  status: StatusEtapaGerenciarEmplacamentosEnum;
  setDados: (dados: IListarEmplacamentosPR[]) => void;
  setTooltipLeft: (left: number) => void;
  setTooltipTop: (top: number) => void;
  setTooltipConteudo: (conteudo: string | JSX.Element) => void;
  setTooltipWidth: (width: number) => void;
  setShowTooltip: (show: boolean) => void;
  abrirModalErroEtapaSemManual: (
    id: number,
    mensagemErro: string,
    etapaComErro: EtapaGerenciarEmplacamentosEnum
  ) => void;
  mensagemErro: string;
  codigoDeBarras: NullableString;
  listar: () => void;
}
export function HandleStatusGerarProcessoDigital({
  idProcesso,
  abrirModalPularGerarProcessoDigital,
  dados,
  etapa,
  status,
  setDados,
  setTooltipLeft,
  setTooltipTop,
  setTooltipConteudo,
  setTooltipWidth,
  setShowTooltip,
  abrirModalErroEtapaSemManual,
  mensagemErro,
  codigoDeBarras,
  listar,
}: HandleStatusGerarProcessoDigitalProps) {
  const handleStatus = (
    status: StatusEtapaGerenciarEmplacamentosEnum,
    mensagem?: string
  ) => {
    dados.forEach((processo) => {
      if (processo.id == idProcesso) {
        processo.statusEtapa = status;
        processo.etapa = EtapaGerenciarEmplacamentosEnum.GERAR_PROCESSO_DIGITAL;

        if (mensagem) {
          processo.observacao = mensagem;
        }
      }
    });
    setDados(dados);
  };

  const onClick = async () => {
    abrirModalPularGerarProcessoDigital(idProcesso);

    setShowTooltip(false);
    setTooltipLeft(0);
    setTooltipTop(0);
    setTooltipConteudo("");
  };

  const etapasPosteriores = [
    EtapaGerenciarEmplacamentosEnum.APROPRIAR_PROCESSO,
    EtapaGerenciarEmplacamentosEnum.PAGAR_IPVA,
    EtapaGerenciarEmplacamentosEnum.EMITIR_LICENCIAMENTO,
    EtapaGerenciarEmplacamentosEnum.SOLICITAR_PLACA,
    EtapaGerenciarEmplacamentosEnum.FINALIZAR_PROCESSO,
  ];

  const etapasMuitoAnteriores = [
    EtapaGerenciarEmplacamentosEnum.ESCOLHER_PLACA,
    EtapaGerenciarEmplacamentosEnum.GERAR_PROCESSO,
  ];

  if (
    !codigoDeBarras ||
    !etapa ||
    (etapa == EtapaGerenciarEmplacamentosEnum.PAGAR_TAXA &&
      status != StatusEtapaGerenciarEmplacamentosEnum.FINALIZADO) ||
    etapasMuitoAnteriores.includes(etapa)
  ) {
    return <Indisponivel />;
  }

  if (
    (etapa && etapasPosteriores.includes(etapa)) ||
    (etapa == EtapaGerenciarEmplacamentosEnum.GERAR_PROCESSO_DIGITAL &&
      status == StatusEtapaGerenciarEmplacamentosEnum.FINALIZADO)
  ) {
    return <Finalizado />;
  }

  if (
    etapa == EtapaGerenciarEmplacamentosEnum.GERAR_PROCESSO_DIGITAL &&
    status == StatusEtapaGerenciarEmplacamentosEnum.ERRO
  ) {
    return (
      <Erro
        onClick={() =>
          abrirModalErroEtapaSemManual(
            idProcesso,
            mensagemErro,
            EtapaGerenciarEmplacamentosEnum.GERAR_PROCESSO_DIGITAL
          )
        }
      />
    );
  }

  if (
    etapa == EtapaGerenciarEmplacamentosEnum.GERAR_PROCESSO_DIGITAL &&
    status == StatusEtapaGerenciarEmplacamentosEnum.PROCESSANDO
  ) {
    return (
      <Processando
        setTooltipLeft={setTooltipLeft}
        setTooltipTop={setTooltipTop}
        setTooltipConteudo={setTooltipConteudo}
        setTooltipWidth={setTooltipWidth}
        setShowTooltip={setShowTooltip}
      />
    );
  }

  return (
    <Play
      acao={onClick}
      setTooltipLeft={setTooltipLeft}
      setTooltipTop={setTooltipTop}
      setTooltipConteudo={setTooltipConteudo}
      setTooltipWidth={setTooltipWidth}
      setShowTooltip={setShowTooltip}
      mensagemTooltip={"Gerar PDF"}
    />
  );
}
